"use client";

import { Checkbox } from "@tillix/ui-atoms/checkbox";
import { FieldControl, FieldLabel, FieldRoot } from "@tillix/ui-atoms/field";
import { InfoIcon } from "lucide-react";
import {
  Controller,
  type FieldValues,
  type Path,
  useFormContext,
} from "react-hook-form";
import { useT } from "@/features/i18n/hooks/use-t";

function InfoMessage() {
  const { t } = useT();
  return (
    <div className="flex items-center gap-2 rounded-sm bg-tenant-howard-county-primary-dark-gray px-2.5 py-3 text-xs">
      <InfoIcon className="size-6 min-w-6" />
      <p>{t("auth.keepSignedInWarning")}</p>
    </div>
  );
}

export default function CheckboxField<TFieldValues extends FieldValues>({
  name,
}: {
  name: string;
}) {
  const form = useFormContext<TFieldValues>();
  const isKeepMeSignedInChecked = form.watch(name as Path<TFieldValues>);
  const { t } = useT();

  return (
    <Controller
      control={form.control}
      name={name as Path<TFieldValues>}
      render={({ field }) => (
        <FieldRoot className="space-y-2" name={field.name}>
          <div className="flex items-center gap-2">
            <FieldControl
              render={(defaultProps) => (
                <Checkbox
                  {...defaultProps}
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <FieldLabel className="text-xs">
              {t("auth.keepSignedIn")}
            </FieldLabel>
          </div>
          {isKeepMeSignedInChecked && <InfoMessage />}
        </FieldRoot>
      )}
    />
  );
}
